import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, SparklesIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
export function PricingCard() {
  return <section id="pricing" className="py-20 md:py-32 px-5 md:px-10 border-b border-rule/60" data-id="element-149">
      <div className="max-w-6xl mx-auto" data-id="element-150">
        <ScrollReveal data-id="element-151">
          <div className="mb-16 md:mb-20 max-w-3xl" data-id="element-152">
            <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-6 font-medium" data-id="element-153">
              — Investment
            </p>
            <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink font-light" data-id="element-154">
              Two ways to move forward.
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mb-16" data-id="element-155">
          {/* MVB - Recommended */}
          <ScrollReveal data-id="element-156">
            <motion.div className="relative bg-ink text-ivory p-8 md:p-12 h-full flex flex-col" data-id="element-157">
              <div className="absolute -top-3 left-8 bg-gold text-ink text-[10px] uppercase tracking-[0.25em] px-3 py-1.5 font-medium" data-id="element-158">
                Recommended
              </div>

              <p className="text-[10px] uppercase tracking-[0.25em] text-ivory/50 mb-4" data-id="element-159">
                01 — Brand
              </p>
              <h3 className="font-serif text-3xl md:text-4xl mb-3 font-light" data-id="element-160">
                Minimum Viable Brand
              </h3>
              <div className="flex items-baseline gap-2 mb-8 pb-8 border-b border-ivory/15" data-id="element-161">
                <span className="font-serif text-5xl md:text-6xl font-light" data-id="element-162">
                  £4,500
                </span>
                <span className="text-sm text-ivory/60" data-id="element-163">+ VAT</span>
              </div>

              <p className="text-base text-ivory/80 leading-relaxed font-light mb-8 flex-1" data-id="element-164">
                A focused brand project to give you the clarity, positioning,
                story, and visual direction needed to launch with confidence.
                The recommended starting point — allowing the brand to be shaped
                properly before launch activity begins.
              </p>

              <div className="space-y-4 text-sm" data-id="element-165">
                <div className="flex items-center gap-3 text-ivory/70" data-id="element-166">
                  <ClockIcon className="w-4 h-4 text-gold" data-id="element-167" />
                  <span data-id="element-168">4-week focused sprint</span>
                </div>
                <div className="text-ivory/60 leading-relaxed pt-4 border-t border-ivory/15" data-id="element-169">
                  <p className="text-[10px] uppercase tracking-[0.25em] text-ivory/40 mb-3" data-id="element-170">
                    Payment Schedule
                  </p>
                  <p className="font-light" data-id="element-171">
                    50% deposit on signing
                    <br data-id="element-172" />
                    50% on completion
                  </p>
                </div>
              </div>
            </motion.div>
          </ScrollReveal>

          {/* Ecommerce - Distinct, reduced rate */}
          <ScrollReveal delay={0.1} data-id="element-173">
            <motion.div className="relative bg-paper border border-gold/40 p-8 md:p-12 h-full flex flex-col overflow-hidden" data-id="element-174">
              {/* Subtle glow */}
              <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-gold/10 blur-3xl pointer-events-none" data-id="element-175" />

              <div className="absolute top-6 right-6 flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-gold-deep font-medium" data-id="element-176">
                <SparklesIcon className="w-3 h-3" data-id="element-177" />
                Limited offer
              </div>

              <p className="text-[10px] uppercase tracking-[0.25em] text-ink-mute mb-4" data-id="element-178">
                02 — Website
              </p>
              <h3 className="font-serif text-3xl md:text-4xl mb-3 text-ink font-light" data-id="element-179">
                Ecommerce Website Sprint
              </h3>

              <div className="flex items-baseline gap-3 mb-2" data-id="element-180">
                <span className="font-serif text-5xl md:text-6xl text-ink font-light" data-id="element-181">
                  £1,400
                </span>
                <span className="text-sm text-ink-mute" data-id="element-182">+ VAT</span>
              </div>
              <p className="text-sm text-ink-mute mb-2" data-id="element-183">
                Normally{' '}
                <span className="line-through decoration-gold/60" data-id="element-184">
                  £3,500 + VAT
                </span>
              </p>
              <div className="inline-flex items-center gap-2 bg-gold/15 text-gold-deep text-[11px] uppercase tracking-[0.18em] px-3 py-1.5 rounded-full font-medium mb-8 self-start" data-id="element-185">
                <span className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" data-id="element-186" />
                Reduced rate · Valid 3 days
              </div>

              <div className="pb-8 border-b border-rule" data-id="element-187" />

              <p className="text-base text-ink-soft leading-relaxed font-light mb-8 flex-1 mt-8" data-id="element-188">
                A focused ecommerce website project to bring the new brand
                online clearly, professionally, and in a way that supports
                enquiries and sales — only available alongside the MVB project
                at this rate.
              </p>

              <div className="space-y-4 text-sm" data-id="element-189">
                <div className="flex items-center gap-3 text-ink-soft" data-id="element-190">
                  <ClockIcon className="w-4 h-4 text-gold" data-id="element-191" />
                  <span data-id="element-192">Begins after brand approval</span>
                </div>
                <div className="text-ink-soft leading-relaxed pt-4 border-t border-rule" data-id="element-193">
                  <p className="text-[10px] uppercase tracking-[0.25em] text-ink-mute mb-3" data-id="element-194">
                    Payment Schedule
                  </p>
                  <p className="font-light" data-id="element-195">100% paid upfront on approval</p>
                </div>
              </div>
            </motion.div>
          </ScrollReveal>
        </div>

        <ScrollReveal delay={0.2} data-id="element-196">
          <p className="text-center text-sm text-ink-mute italic font-serif max-w-xl mx-auto" data-id="element-197">
            Pricing reflects the scope discussed during our clarity call. Final
            figures may be refined as the project takes shape.
          </p>
        </ScrollReveal>
      </div>
    </section>;
}